import React from 'react'
import ChristianWenzImg from '../../images/speakers/Christian-Wenz-2020.jpg'

const ChristianWenz = () => (
<section id="speaker" className="parallax-section">
	<div className="container">
    <br /><br /><br /><br /><br /><br />
		<div className="row">
            <div className="col-md-12 col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                <div className="team-wrapper">
					<h2>Christian Wenz</h2>
                    <div className="row">
                        <div className="col-md-6">
                            <img src={ChristianWenzImg} className="img-responsive" alt="Christian Wenz" />
                            <ul className="social-icon">
                                <li><a href="https://www.linkedin.com/in/christianwenz/" target="_blank" className="fa fa-linkedin wow fadeIn"></a></li>
                                <li><a href="https://twitter.com/chwenz" target="_blank" className="fa fa-twitter wow fadeIn"></a></li>
                            </ul>
                        </div>
                        <div className="col-md-5">
                        <p>
                        Christian Wenz is an author, consultant and trainer focussing on web technologies and web application security. <br />
                        He wrote or co-wrote over 100 books, is a fixture at international developer conferences since 2001, and a Microsoft MVP for ASP.NET since 2004. <br /><br />
                        His day job includes conducting security audits, migrating old code bases, implementing complex web applications and helping companies choose the right mix of web technologies.
                        </p>
                        </div>
                    </div>
                    <div className="row">
                        <h4>Talk: The Ten Most Critical Web Application Security Risks: OWASP Top Ten</h4>
                        <p>
                        Since 2003, the Open Web Application Security Project curates a list of the top ten secuity risks for web applications. <br />
                        The 2017 list is the most current one, trying to mix both common and upcoming attacks, and to stay relevant in an ever-changing web world. Time to get an up-to-date refresh on how to create secure web applications, including attacks that did not make the list (but should be in there).
                        </p>
                    </div>
				</div>
			</div>
        </div>
    </div>
</section>
)

export default ChristianWenz



// WEBPACK FOOTER //
// ./src/pages/speakers/christian-wenz.js